import React, { Component } from 'react';
import { Container, Row, Col, Form, Button, Image, Modal } from 'react-bootstrap';
import { Bounce } from 'react-activity';
import ReCAPTCHA from "react-google-recaptcha";
import Bullet from '../../Images/Bullet.svg';
import BulletCheck from '../../Images/Bullet-check.svg';
import Backend from '../../Backend';
import NavbarComponent from '../Navbar';
import { store } from 'react-notifications-component';
import Connection from '../../Calls';
import ModeColorComponent from '../../ColorMode';
import LogoWirebit from '../../Images/Logos/LogoAzul.png';
import HtmlModal from '../Landing/pages/components/footer/htmlModal';
import termsHTML from '../../Components/Landing/pages/components/footer/htmls/termsContent';
import SelectCountry from '../Select/SelectCountries';
import countries from '../Select/countryOptions';
import es from '../../translate/es';
import en from '../../translate/en';
import './index.css';
import showNotification from '../../Helpers/ShowNotification';

var countryForgot; //send country for signup
var countryConfirm; //Resend confirmation

class SignupCardIndex extends Component {
  constructor(props) {
    super(props)
    this.state = {
      email: '',
      card: '',
      password: '',
      confirmPassword: '',
      key: '',
      reCaptcha: '',
      showload: false,
      // -------------- //
      validatePass8: false,
      validatePassMayus: false,
      validatePassMinus: false,
      validatePassDigit: false,
      validatePassEspecial: false,
      validatePassSame: false,
      // -------------- //
      showModal: false,
      showloadConfirm: false,
      countryConfirm: '',
      emailConfirm: '',
      aceptConfirm:false,
      text: en,
      showTerms: false
    }
  }

  componentWillMount() {
    this.bQk7VZx7();
    this.setState({country: countryConfirm})
    if(this.props.lan === 'es'){
      this.setState({text:es})
    } else{
      this.setState({text:en})
    }
  }

  bQk7VZx7() {
    const self = this;
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XJPW023"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.bQk7VZx7(confirmation, date, result, "Bm3h642", combination, "XJPW023", response => {
      self.setState({
        vertice: response.payload.r03
      })
    });
  }

  handleChange(value) {
    if (value !== null) {
      this.setState({ reCaptcha: "confirmed" });
    }
  }

  validatePassword() {
    const self = this;

    if (self.state.password.length >= 8) {
      self.setState({ validatePass8: true });
    } else {
      self.setState({ validatePass8: false });
    }

    if (/(?:.*[A-Z]){1}/.test(this.state.password)) {
      self.setState({ validatePassMayus: true });
    } else {
      self.setState({ validatePassMayus: false });
    }

    if (/(?:.*[a-z]){1}/.test(this.state.password)) {
      self.setState({ validatePassMinus: true });
    } else {
      self.setState({ validatePassMinus: false });
    }

    if (/(?:.*\d){1}/.test(this.state.password)) {
      self.setState({ validatePassDigit: true });
    } else {
      self.setState({ validatePassDigit: false });
    }

    if (/[`~!@#$%^&*()_°¬|+\-=?;:'",.<>\]\\]/gi.test(this.state.password)) {
      self.setState({ validatePassEspecial: true });
    } else {
      self.setState({ validatePassEspecial: false });
    }

    if (this.state.password === this.state.confirmPassword && this.state.password !== "" && this.state.confirmPassword !== "") {
      self.setState({ validatePassSame: true });
    } else {
      self.setState({ validatePassSame: false });
    }

  }

  validateConfirmPassword() {
    const self = this;
    if (this.state.confirmPassword === this.state.password && this.state.confirmPassword !== "" && this.state.password !== "") {
      self.setState({ validatePassSame: true });
    } else {
      self.setState({ validatePassSame: false });
    }
  }

  sendData() {
    const self = this;
    const { text } = this.state
    if(!this.state.aceptConfirm){
      showNotification.error(text.Register.messageError.errorTerms,3000);
      return
    }
    let card = this.state.card.replaceAll(" ","");
    if (card.length != 16){
      showNotification.error(text.Register.messageError.errorCard,3000);
      return
    }
    if (this.state.reCaptcha == "") {
      showNotification.error(text.Register.messageError.errorCaptcha,3000);
      return
    }
    if (/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.state.email) == false) {
      showNotification.error(text.Register.messageError.errorEmail,3000);
      return
    }
    if (this.state.email === "" || this.state.password === "" || this.state.confirmPassword === "" || this.state.card === "") {
      showNotification.error(text.Register.messageError.errorEmpty,3000);
      return
    }
    if (this.state.password !== this.state.confirmPassword){
      showNotification.error(text.Register.messageError.errorPwd,3000);
      return
    }
    self.setState({ showload: true, buttonLocked: true });
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XWBX203"), latitude = "0", longitude = "0";
    let whiskas = Connection.RThzHrsb(self.state.confirmPassword)
    let card_enc = Connection.RThzHrsb(card);
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.QCJQ7DUk(confirmation, date, result, "Apxm2aZ", combination, "XWBX203", "1", whiskas, response => {
      let key = response.payload.r03;
      Connection.QCJQ7DUk(confirmation, date, result, "Apxm2aZ", combination, "XWBX203", "1", card_enc, response => {
        let key_c = response.payload.r03;
        Backend.RegisterWithCard(key, self.state.email, key_c, self.state.reCaptcha, response => {
          if (response.status.code === "0") {
            showNotification.success(response.payload?.message,3000);
            self.setState({ email: '', card: '', password: '', confirmPassword: '', key: '', reCaptcha: '', showload: false, validatePass8: false, validatePassMayus: false, validatePassMinus: false, validatePassDigit: false, validatePassEspecial: false, validatePassSame: false });
            setTimeout(function () { self.props.data.history.push("/") }, 2000);
          } else {
            showNotification.error(response.status.description,3000);
            self.setState({ showload: false, buttonLocked: true });
          }
        });
      });
    });
  }

  handleCheck(val) {
    const self = this;
    self.setState({ aceptConfirm: val.target.checked });
  }

  // redirecTerms() {
  //   var win = window.open('https://wirebit.com/terms', '_blank');
  //   win.focus();
  // }

  redirectLanding(){
    this.props.data.history.push("/");
  }

  format_card(card){
    card = card.replaceAll(/\D/g, "");
    // For some reason if you dont return here it skips the previous replace
    if (card == ''){
      return card;
    }
    // Remove spaces, limit to 16, then separate in groups of 4 digits for better readability
    return card.replaceAll(" ","").substring(0, 16).match(/.{1,4}/g)?.join(" ")
  }

  render() {
    return (
      <div className='newSignupBG'>
        {/* <NavbarComponent data={this.props} selected="register" /> */}
        <div className="wrapper-background">
          <div className="wrapper-signup">
            <Container>
              <div className='d-flex justify-content-center' style={{marginBottom: '15px'}}>
                <Image onClick={() => { this.redirectLanding() }} src={LogoWirebit} style={{ width: 150, cursor: 'pointer' }} />
              </div>
              <Row>
                <Col md={12}>
                  <div className="border-title-separator-container">
                    <div className="border-title-separator-container-left" style={{ width: "100%" }}>
                      <div className='d-flex justify-content-center'>
                        <span className='title-login'>{this.state.text.Register.title}</span>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col md={12}>
                  <div>
                    <Row>
                      <Col md={12}>
                        <Form.Group>
                          <Form.Label className="label-font-input">{this.state.text.Register.L_mail}</Form.Label>
                          <center>
                            <Col>
                              <Form.Control
                                autoComplete='off'
                                type="email"
                                className="input-signup"
                                value={this.state.email}
                                onChange={(email) => { this.setState({ email: email.target.value }) }}
                              />
                            </Col>
                          </center>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={12}>
                        <Form.Group>
                          <Form.Label className="label-font-input">{this.state.text.Register.L_card}</Form.Label>
                          <center>
                            <Col>
                              <Form.Control
                                autoComplete='off'
                                type="text"
                                className="input-signup"
                                value={this.state.card}
                                onChange={(card) => {this.setState({ card: this.format_card(card.target.value) }) }}
                              />
                            </Col>
                          </center>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={12}>
                        <Form.Group>
                          <Form.Label className="label-font-input">{this.state.text.Register.L_password}</Form.Label>
                          <center>
                            <Col>
                              <Form.Control
                                type="password"
                                className="input-signup"
                                value={this.state.password}
                                onChange={(password) => { this.setState({ password: password.target.value }) }}
                                onKeyUp={() => { this.validatePassword() }}
                              />
                            </Col>
                          </center>
                        </Form.Group>
                      </Col>
                      <Col md={12}>
                        <Form.Group>
                          <Form.Label className="label-font-input">{this.state.text.Register.L_cPassword}</Form.Label>
                          <center>
                            <Col>
                              <Form.Control
                                className="input-signup"
                                type="password"
                                value={this.state.confirmPassword}
                                onChange={(confirmPassword) => { this.setState({ confirmPassword: confirmPassword.target.value }) }}
                                onKeyUp={() => { this.validateConfirmPassword() }}
                              />
                            </Col>
                          </center>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Form.Group>
                      <Col md={12}>
                        <div className="container-messages-signup">
                          <p className={!this.state.validatePass8 ? "text-validate-pwd" : "success-validate-pwd"}>
                            <Image className="icono-check-text-password" src={!this.state.validatePass8 ? Bullet : BulletCheck} />
                            {this.state.text.General.PassRequirements.req1}.
                          </p>
                          <p className={!this.state.validatePassMayus ? "text-validate-pwd" : "success-validate-pwd"}>
                            <Image className="icono-check-text-password" src={!this.state.validatePassMayus ? Bullet : BulletCheck} />
                            {this.state.text.General.PassRequirements.req2}.
                          </p>
                          <p className={!this.state.validatePassMinus ? "text-validate-pwd" : "success-validate-pwd"}>
                            <Image className="icono-check-text-password" src={!this.state.validatePassMinus ? Bullet : BulletCheck} />
                            {this.state.text.General.PassRequirements.req3}.
                          </p>
                          <p className={!this.state.validatePassDigit ? "text-validate-pwd" : "success-validate-pwd"}>
                            <Image className="icono-check-text-password" src={!this.state.validatePassDigit ? Bullet : BulletCheck} />
                            {this.state.text.General.PassRequirements.req4}.
                          </p>
                          <p className={!this.state.validatePassEspecial ? "text-validate-pwd" : "success-validate-pwd"}>
                            <Image className="icono-check-text-password" src={!this.state.validatePassEspecial ? Bullet : BulletCheck} />
                            {this.state.text.General.PassRequirements.req5}.
                          </p>
                          <p className={!this.state.validatePassSame ? "text-validate-pwd" : "success-validate-pwd"}>
                            <Image className="icono-check-text-password" src={!this.state.validatePassSame ? Bullet : BulletCheck} />
                            {this.state.text.General.PassRequirements.req6}.
                          </p>
                        </div>
                      </Col>
                    </Form.Group>
                    <Form.Group>
                      <Col className='check-sign'>
                        <Form.Check onChange={(e) => { this.handleCheck(e) }} inline label={this.state.text.Register.agree1} type={'checkbox'} id={"inline-'checkbox"} />
                        <span style={{marginLeft:5}} className='terms-link' onClick={()=>this.setState({showTerms: true})}>{this.state.text.Register.agree2}</span>
                      </Col>
                    </Form.Group>
                    <div>
                      <center style={{ marginBottom: 0 }}>
                        {
                          this.state.vertice &&
                          <ReCAPTCHA
                            theme="light"
                            key="1"
                            sitekey={this.state.vertice}
                            onChange={this.handleChange.bind(this)}
                          />
                        }
                      </center>
                    </div>
                    <div>
                      <div style={{ marginTop: 30, textAlign: "center" }}>
                        <Button className="signup-button" style={{width: '96%'}} variant="primary" onClick={() => { this.sendData() }} disabled={this.state.showload}>
                          {
                            (this.state.showload)
                              ? <Bounce size={20} color={"#FFFFFF"} animating={this.state.showload} />
                              : <span className="label-btn-login">{this.state.text.Register.btn}</span>
                          }
                        </Button>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
        <HtmlModal
          show={this.state.showTerms}
          close={()=>this.setState({showTerms:false})}
          html={termsHTML}
        />
        <ModeColorComponent onToggleSwitchChange={this.props.onToggleSwitchChange} checked={this.props.checked} />
      </div>
    );
  }

} export default SignupCardIndex;
